import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function ListeFournisseursLentilles() {
  const [fournisseursLentilles, setFournisseursLentilles] = useState([]);

  useEffect(() => {
    function getFournisseursLentilles() {
      axios
        .get(`${API_URL}/api/lentilles`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseursLentilles(data);
        });
    }
    getFournisseursLentilles();
  }, []);

  return (
    <div className="listeMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Liste des fournisseurs lentilles</title>
      </Helmet>
      <h1>Liste des fournisseurs lentilles</h1>
      <div>
        {fournisseursLentilles ? (
          fournisseursLentilles.map((fournisseurLentilles) => {
            return (
              <Link to={`/fournisseurs-lentilles/${fournisseurLentilles.id}`}>
                <img
                  src={`${API_URL}/images/fournisseurs-lentilles/${fournisseurLentilles.id}.png`}
                  alt={fournisseurLentilles.nom}
                  className="listeLogo"
                />
              </Link>
            );
          })
        ) : (
          <li>Loading</li>
        )}
      </div>
    </div>
  );
}

export default ListeFournisseursLentilles;
